import React from 'react'
import ToastError from './ToastError'

export * from './ToastError'
export default React.memo(ToastError)
